<div fxLayout="column" class="container">
  <div *ngFor="let yarnType of yarnTypes" class="yarn-wrapper" fxLayout="row" fxLayoutGap="8px">
    <span #name class="yarn-type-name" [matTooltipDisabled]="!showTooltip" [matTooltip]="yarnType.name">{{ yarnType.name }}</span>
    <span *ngIf="showFirstRawMaterial" class="raw-material">{{ yarnType.getFirstRawMaterial() }}</span>
  </div>
</div>
